import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { MCUser, UserProfile } from './auth.models'
import { environment } from '@env'
import { ignoreTenant } from '@core/requests/tenant.interceptor'

@Injectable()
export class AuthApi {
  readonly #http = inject(HttpClient)

  fetchMCUser(): Observable<MCUser> {
    return this.#http.get<MCUser>(environment.API.USERS, { context: ignoreTenant() })
  }

  fetchProfile(): Observable<HttpResponse<UserProfile>> {
    return this.#http.get<UserProfile>(environment.API.USER_PROFILE, {
      observe: 'response',
      context: ignoreTenant(),
    })
  }

  updateUserProfile(userProfile: UserProfile): Observable<UserProfile[]> {
    return this.#http.put<UserProfile[]>(`${environment.API.USER_PROFILE}s`, [userProfile], {
      headers: new HttpHeaders(''),
    })
  }
}
